export default class CourseNode {
    constructor(value) {
        this.value = value;
        this.prev = null;
        this.next = null;
    }
}